import styles from './about.module.css';
import FAB from '../../helpers/fab'

const About = () => {
  const isMobile = window.innerWidth <= 900;

  //Styles
  const fadeInLeft = `${styles.aboutInner} ${styles.fadeInLeft}`;
  const fadeInRight = `${styles.aboutInner} ${styles.fadeInRight}`;
  const imageStyles = `${styles.aboutImage} ${styles.zoomIn}`

  return (
    <section className={styles.about}>
      <h2>About Us</h2>

      <div className={`${fadeInLeft} container`}>
        <div className={styles.aboutText}>
          <b>Cabinets & Countertops</b>
          <p>
            A family-run business for over 30 years, 1 Stop Kitchens & Countertops is a one-stop-shop for all your kitchen needs! Servicing Fredericton, NB and surrounding areas, 1 Stop builds, supplies and installs custom and factory-made kitchen and bathroom cabinets, countertops and hardware. We offer laminate, quartz and butcher block countertops and are proud to be your exclusive supplier of locally made TRIANGLE Kitchen Cabinets from Moncton, NB.
          </p>
          <p>
            Call and book an appointment OR stop into our fully equipped Showroom located at 7 Royal Parkway on Fredericton's north side Monday - Friday 8 a.m. - 5 p.m. for a free consultation and receive no-obligation pricing to start creating your dream kitchen today!
          </p>

          <b>Outstanding Customer Service </b>
          <p>
            Our friendly staff takes pride in pleasing our customers and fulfilling their dreams for their home. Through 20-20 technology we are able to turn your dream kitchens into a reality while at the same time providing quality craftsmanship at an affordable price guaranteed!
          </p>
        </div>
        <div className={imageStyles}>
          <img src="https://ik.imagekit.io/1stopkitchens/images/about/building.png" alt="1 Stop Kitchens" />
        </div>
      </div>

      <div className={`${fadeInRight} container`}>
        {!isMobile && <div className={imageStyles}>
          <img src="https://ik.imagekit.io/1stopkitchens/images/about/personalized_approach.png" alt="Personalized Approach" />
        </div>}
        <div className={styles.aboutText}>
          <h2>Personalized Approach</h2>
          <p>
            Owned by a licensed cabinet maker, 1 Stop Kitchens & Countertops brings more than 35 years of industry knowledge and expertise to every job they deliver, ensuring you always receive top quality products and service.
          </p>
          <p>1 Stop Kitchens employs six talented craftspeople</p>
        </div>
        {isMobile && <div className={imageStyles}>
          <img src="https://ik.imagekit.io/1stopkitchens/images/about/personalized_approach.png" alt="Personalized Approach" />
        </div>}
      </div>

      <div className={`${fadeInLeft} container`}>
        <div className={styles.aboutText}>
          <h2>Local Supporting Local</h2>
          <p>
            Proudly rooted on Fredericton’s North Side, <strong>1 Stop Kitchens & Countertops</strong> is a 
            family-owned business built on community values. We’re passionate about supporting local—
            from the products we offer to the people we champion.
          </p>
          <p>
            We proudly feature New Brunswick-made products such as 
            <strong> Triangle Kitchens</strong>, helping customers bring 
            quality, locally crafted materials into their homes. Our support doesn’t stop there—
            we actively invest in the community by backing local athletics and organizations like 
            <strong> Leo Hayes High School</strong> and <strong>Dressage New Brunswick</strong>.
          </p>
          <p>
            At 1 Stop Kitchens, supporting local isn’t just a slogan—it’s who we are. 
            When you shop with us, you're helping build a stronger, more connected New Brunswick.
          </p>
        </div>
        <div className={imageStyles}>
          <img src="https://ik.imagekit.io/1stopkitchens/images/about/support-local.png" alt="Support Local" />
        </div>
      </div>
      
      <FAB />
    </section>
  )
}


export default About
